import { Modal } from "./Modal";
import BasicForm from "./BasicForm";
import ItemForm from "../views/ItemForm";
import IndentForm from "../views/IndentForm";
import ReceiptForm from "../views/ReceiptForm";

export default function CreateModal({ type, close, create, catalogue }) {
  if (type === "inventory") {
    return (
      <Modal title="Add inventory item" subtitle="CATALOGUE" onClose={close} size="lg">
        <ItemForm
          vendors={catalogue.vendors}
          onClose={close}
          onSubmit={(x) => create("items", x)}
        />
      </Modal>
    );
  }
  if (type === "indents") {
    return (
      <Modal title="Create department indent" subtitle="INDENT" onClose={close} size="lg">
        <IndentForm
          departments={catalogue.departments}
          items={catalogue.items}
          onClose={close}
          onSubmit={(x) => create("indents", x)}
        />
      </Modal>
    );
  }
  if (type === "receiving") {
    return (
      <Modal title="Record purchase receipt" subtitle="GRN" onClose={close} size="lg">
        <ReceiptForm
          vendors={catalogue.vendors}
          items={catalogue.items}
          onClose={close}
          onSubmit={(x) => create("receipts", x)}
        />
      </Modal>
    );
  }
  if (type === "vendors") {
    return (
      <Modal title="Add vendor" subtitle="SUPPLY PARTNER" onClose={close}>
        <BasicForm
          submit="Save vendor"
          onClose={close}
          onSubmit={(x) => create("vendors", { ...x, opening_balance: Number(x.opening_balance || 0) })}
          fields={[
            { key: "name", label: "Vendor name", required: true },
            { key: "gem_contract", label: "GEM contract number" },
            { key: "phone", label: "Phone number" },
            { key: "email", label: "Email" },
            { key: "address", label: "Address", full: true },
            { key: "credit_terms", label: "Credit terms", type: "select", options: ["Net 30", "Net 45", "Net 60", "Advance"] },
            { key: "category", label: "Category", type: "select", options: ["Pharmaceuticals", "Equipment", "Consumables"] },
            { key: "opening_balance", label: "Opening balance (₹)", type: "number", hint: "Positive = we owe them" },
          ]}
        />
      </Modal>
    );
  }
  if (type === "departments") {
    return (
      <Modal title="Add department" subtitle="ISSUE POINT" onClose={close}>
        <BasicForm
          submit="Add department"
          onClose={close}
          onSubmit={(x) => create("departments", x)}
          fields={[
            { key: "name", label: "Department name", required: true },
            { key: "floor", label: "Location / floor" },
            { key: "head", label: "Department head" },
            { key: "contact", label: "Contact number" },
          ]}
        />
      </Modal>
    );
  }
  return null;
}
